import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { usePeopleWithDisabilitiesChartsDataContext } from './hooks/usePeopleWithDisabilitiesChartsDataContext';

export const Disabilities = () => {
    const { chartData } = usePeopleWithDisabilitiesChartsDataContext();

    return (
        <SimpleBars
            title={'Deficiências'}
            horizontal={true}
            subtitles={
                chartData?.disabilities?.map((item) => item.description) || []
            }
            values={chartData?.disabilities?.map((item) => item.total  ||  0) || []}
        />
    );
};
